import { render, staticRenderFns } from "./rb-rox-upload-prescription.vue?vue&type=template&id=64eb1fb4&scoped=true"
import script from "./rb-rox-upload-prescription.vue?vue&type=script&lang=js"
export * from "./rb-rox-upload-prescription.vue?vue&type=script&lang=js"
import style0 from "./rb-rox-upload-prescription.vue?vue&type=style&index=0&id=64eb1fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb1fb4",
  null
  
)

export default component.exports